import { render, staticRenderFns } from "./DxMachineryForm.vue?vue&type=template&id=4d47be0e&"
import script from "./DxMachineryForm.vue?vue&type=script&lang=js&"
export * from "./DxMachineryForm.vue?vue&type=script&lang=js&"
import style0 from "./DxMachineryForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports